// extracted by mini-css-extract-plugin
module.exports = {"brand":"#ffa0cc","typo1":"#9e9e9e","typo3":"#424242"};